import FormModal from './FormModal.vue'
FormModal.install = function (Vue) {
  Vue.component(FormModal.name, FormModal)
}
export {
  FormModal
}
